import { useHasSession } from "@/shared/hooks/usePosOrderTableSessionHook";
import IconButton from "../IconButton/IconButton";
import { useCartQuantity } from "@/shared/hooks/useCartHook";

interface PosCartSummaryProps {
  onClickShowCart: () => void;
}

const PosCartSummary = ({ onClickShowCart }: PosCartSummaryProps) => {
  const cartQuantity = useCartQuantity();
  const hasSession = useHasSession();

  if (cartQuantity === 0 && !hasSession) {
    return null;
  }
  return (
    <div className="z-[999] right-[1rem] bottom-4 fixed">
      <div className="relative">
        <div
          className="absolute left-[-1rem] top-[-1rem] flex h-12 w-12 items-center justify-center rounded-full bg-error text-white"
          style={{ fontWeight: 900 }}
        >
          {cartQuantity}
        </div>

        <IconButton
          size="bigger"
          onClick={() => onClickShowCart()}
          variants="basket"
        />
      </div>
    </div>
  );
};

export default PosCartSummary;
